import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import WareHouseForm from "../../../component/wareHouseForm";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";

export default function WareHouseManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchWareHouse = async () => {
    await axiosInstance.get(`/warehouse/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/warehouse/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            if(res?.data?.status == 1) navigate("/admin/quan-ly-kho-hang");
          });
      } else {
        await axiosInstance.post(`/warehouse/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            console.log(res?.data?.status)
            if(res?.data?.status == 1) navigate("/admin/quan-ly-kho-hang");
          });
      }
      
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchWareHouse();
    form.resetFields();
  }, [form, id]);

  return (
    <WareHouseForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
